import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

const CostCenterActionsToggle = ({ costCenter, t, handleClick = () => {} }) => (
  <Form.Button
    text={t(costCenter.active ? 'actions.deactivate' : 'actions.activate')}
    color={costCenter.active ? 'outline-warning' : 'outline-info'}
    extraClassName={'btn-sm'}
    isLoading={costCenter.isLoading}
    onClick={(e) => {
      e.preventDefault();
      handleClick(costCenter.id);
    }}
  />
);

export default translate()(CostCenterActionsToggle);



// WEBPACK FOOTER //
// src/modules/secured/modules/cost_centers/components/list/actions/CostCentersActionsToggle.js